import React from "react"
import styled from "styled-components"

export default function CategoryPageHero({ title, image }) {
  return (
    <Container image={image}>
      <Title>{title}</Title>
    </Container>
  )
}
const Container = styled.div`
  width: 100vw;
  height: 50vh;
  position: relative;
  background-image: ${({ image }) => `url('${image}')`};
  background-position: center;
  background-size: cover;
  overflow: hidden;
`
const Title = styled.h1`
  position: absolute;
  padding-top: 0.5rem;
  right: 0;
  color: white;
  margin-bottom: 0rem;
  transform: translate(0, -100%) rotate(-90deg);
  transform-origin: right bottom;
  text-align: right;
  height: fit-content;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  white-space: normal;
  padding: 0.75rem 1rem;
  background-color: rgb(228 153 153 / 50%);
  box-shadow: -2px -2px 8px rgb(228 153 153 / 50%);
  width: 50vh;
  color: #f9f9f9;
`
